<template>
	<el-dialog
			top="0" :show-close="false"
			:visible.sync="dialogVisible" class="share"
			width="400px">
		<div id="imageDom">
			<div class="logo">
				<img src="../../assets/img/logo.png" alt="">心理亦笙
			</div>
			<div class="doctorDel" :style="'backgroundImage: url('+user.headImgPath+')'">
				<div class="content">
					<h2>{{ user.fullName }} {{ user.enName }}</h2>
					<p class="eduBackground text">{{ user.eduBackground }}</p>
					<p class="company text">{{ user.company }}{{ user.department }}{{ user.job }}</p>
					<div class="text abodeCity">
						<p>所在地：<span>{{ user.abodeCity }}</span></p>
						<p>累计预约：<span>{{ user.consultationCount }} </span>人</p>
						<p>从业<span>{{ workYear }}</span>年</p>
					</div>
					<div class="line"></div>
					<div class="square"><span></span><span></span><span></span><span></span></div>
				</div>
				<p class="name">Neuropsych Studio</p>
			</div>
			<div class="indication">{{ indicationList | indicationFmt }}</div>
			<div class="signature">
				<p v-if="user.signature" class="motto" :title="user.signature">“{{ user.signature }}”</p>
				<div id="qrImg"></div>
				<div style="clear:both;"></div>
			</div>
		</div>
		<el-button class="download" @click="clickGeneratePicture"><img src="../../assets/img/download.png" alt="">
		</el-button>
	</el-dialog>
</template>

<script>
  import base from "@/api/common";
  import QRCode from 'qrcodejs2'
  import html2canvas from "html2canvas"

  export default {
    name: "share",
    props: ['user', 'indicationList', 'workYear'],
    data() {
      return {
        dialogVisible: false,
        opts: {
          useCORS: true,
          allowTaint: true
        },
        websiteUrl: base.web_url,

        shareLoading: true,
        shareError: false,
      }
    },
    async mounted() {

    },
    methods: {
      initShare1() {
        // 避免跨域
        $('#qrImg').html('');
        // 二维码生成
        let that = this;
        that.shareLoading = true;
        that.shareError = false;
        new QRCode('qrImg', {
          width: 100,
          height: 100,
          text: that.websiteUrl + '/' + that.user.account,
        });
        // 背景图转base64
        that.$ajax.get(that.user.headImgPath, {
          responseType: 'blob',
          withCredentials: false,
          }).then(res => {
          const blob = new Blob([res.data], {type: 'image/png'});
          let oFileReader = new FileReader();
          oFileReader.onloadend = function (e) {
            // 此处拿到的已经是 base64的图片了
            let base64 = e.target.result;
            that.user.headImgPath = base64;
            that.$nextTick(() => {
              that.shareLoading = false;
            });
          };
          oFileReader.readAsDataURL(blob);
        }).catch(err => {
          that.$message.error('生成分享图片失败.');
          that.shareError = true;
          console.error(err);
        });
      },
      initShare() {
        // 避免跨域
        $('#qrImg').html('');
        // 二维码生成
        let that = this;
        that.shareLoading = true;
        that.shareError = false;
        new QRCode('qrImg', {
          width: 100,
          height: 100,
          text: that.websiteUrl + '/' + that.user.account,
        });
        // 背景图转base64
        let base64="";
        let img = new Image();
        img.setAttribute("crossOrigin",'anonymous');
        img.crossOrigin="*";
        img.onload=function(){
          let canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          let ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, img.width, img.height);
          let base64 = canvas.toDataURL("image/png");
          that.user.headImgPath = base64;
          that.$nextTick(() => {
            that.shareLoading = false;
          });
        };
        img.src= that.user.headImgPath;
      },
      clickGeneratePicture() {
        if (this.shareError) {
          this.$message.error('生成分享图片失败');
          return;
        }
        if (this.shareLoading) {
          this.$message.warning('图片生成中,请稍后');
          return;
        }
        html2canvas(document.querySelector("#imageDom"), this.opts).then(canvas => {
          this.imgUrl = canvas.toDataURL("image/png");

          this.saveFile(this.imgUrl, 'Share_' + this.user.account);
          this.dialogVisible = false;
        });
      },
      saveFile(data, filename) {
        const save_link = document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
        save_link.href = data;
        save_link.download = filename;
        const event = document.createEvent('MouseEvents');
        event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
        save_link.dispatchEvent(event);
      },
    },
    filters: {
      indicationFmt(indications) {
        if (indications) {
          let skills = [];
          $(indications).each((i, o) => {
            if (o && o.cnName) {
              skills.push(o.cnName);
            }
          });
          return skills.join("、");
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
	@import "../../assets/css/share";
	
	.indication {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
</style>